export default __webpack_public_path__ + "static/media/about-background.fce6fc3e.png";